<template>
  <v-layout wrap class="channel-hotels-container">
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="hotels"
        :page.sync="pagination"
        :items-per-page.sync="itemsPerPage"
        :server-items-length="total"
        :footer-props="{itemsPerPageOptions: [10, 25, 50, 75, 100]}"
        :hide-default-footer="total <= itemsPerPage"
        :loading="loading">
        <template v-slot:item="props">
          <tr>
            <td>
              <v-layout wrap>
                <v-flex xs8 sm10>
                  <h3>{{ props.item.info.name }}</h3>
                  <p>{{ props.item.propertyCode }}</p>
                </v-flex>
                <v-flex xs4 sm2>
                  <v-btn outlined color="primary" @click="selectHotel(props.item)" style="float: right;">
                    {{ $t('hotel.create.select') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-snackbar
      :color="snackbar.result"
      v-model="snackbar.value"
      :bottom="true"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn
        color="white"
        text
        @click="snackbar.value = false">
        {{$t("close")}}
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  export default {
    name: 'KognitivChannel',
    data() {
      return {
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        hotels: [],
        pagination: undefined,
        total: 0,
        loading: false,
        itemsPerPage: 10,
        headers: [
          { text: this.$i18n.t('hotel.create.hotelName'),
            sortable: false, value: 'name' },
          ]
      };
    },
    watch: {
      pagination: {
        handler (pagination) {
          this.fetchData(pagination === 0 ? 0 : pagination - 1);
        },
        deep: true
      },
      itemsPerPage: {
        handler (itemsPerPage) {
          this.itemsPerPage = itemsPerPage;
          this.fetchData(this.pagination === 0 ? 0 : this.pagination - 1);
        },
        deep: true
      }
    },
    mounted() {
      this.pagination = 0;
    },
    methods: {
      fetchData(pagination) {
        this.loading = true;
        const offset = pagination * this.itemsPerPage;
        this.$http.get('kognitiv/channel?limit='.concat(this.itemsPerPage)
          .concat('&offset=').concat(offset)).then((body) => {
          this.hotels = body.data.properties;
          this.total = body.data.totalMatchedProperties;
          this.loading = false;
        });
      },
      selectHotel(hotel) {
        this.$http.get('hotels/kognitiv/'.concat(hotel.info.propertyCode))
          .then((data) => {
            if (Object.prototype.toString.call(data.body) === '[object String]') {
              this.globalEvents.$emit('create_hotelCreated', true);
              this.globalEvents.$emit('create_selectedHotel', hotel);
            } else {
              this.snackbar.result = 'error';
              this.snackbar.text = this.$i18n.t('hotel.kognitiv.exists');
              this.snackbar.value = true;
            }
        });
      }
    }
  };

</script>

<style lang="scss">
  @import "../../../assets/scss/variables";

  .channel-hotels-container {
    div {

      p {
        padding: 0;
        margin: 0;
        color: $primary;
      }

      td {
        padding-top: 10px !important;
        padding-bottom: 10px !important;
      }
    }
  }
</style>
